module.exports = __webpack_public_path__ + "static/media/E14.dde1f4b4.jpg";